import { useState } from 'react';
import { NdaAgreementWindow } from './NdaAgreementWindow';

export function Nda() {
  const [showWindow, setShowWindow] = useState(false);

  return (
    <div className="flex-1 overflow-y-auto p-6 flex flex-col">
      <div className="text-sm leading-relaxed text-gray-700 flex-1 overflow-y-auto">
        <div className="border-b border-gray-200 pb-6 mb-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-2">
            NON-DISCLOSURE AGREEMENT
          </h2>
          <p className="text-xs text-gray-500">
            Effective Date: January 29, 2030
          </p>
        </div>

        <div className="space-y-4">
          <section>
            <h3 className="font-semibold text-gray-900 mb-2">1. PURPOSE</h3>
            <p>
              This Non-Disclosure Agreement (&quot;NDA&quot;) is entered into
              between Laura.ai (&quot;Disclosing Party&quot;) and the
              undersigned employee (&quot;Receiving Party&quot;) to protect
              confidential information and trade secrets related to the
              company&apos;s operations, projects, and strategic initiatives.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-gray-900 mb-2">
              2. CONFIDENTIAL INFORMATION
            </h3>
            <p>
              Confidential information includes, but is not limited to: source
              code, architectural designs, business strategies, financial data,
              client information, security protocols, and any other proprietary
              information marked as confidential or understood to be
              confidential in nature.
            </p>
          </section>

          <section>
            <p className="font-bold text-gray-900 my-4">
              ON-CALL DEVELOPERS: Signing this NDA is mandatory to use internal
              tools including the Laura Monitor Center.
            </p>
          </section>

          <section className="bg-gray-100 border border-gray-300 p-4 rounded">
            <p className="font-bold text-gray-900">
              ⚠ WARNING: Signing this NDA is required for badge activation.
            </p>
          </section>

          <button
            onClick={() => setShowWindow(true)}
            className="mt-4 px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded hover:bg-gray-800 transition-colors"
          >
            View Full Agreement
          </button>

          <div className="border-t border-gray-200 pt-6 mt-8">
            <p className="text-xs text-gray-500">
              Laura.ai Compliance Team | Document ID: NDA-2025-001
            </p>
          </div>
        </div>
      </div>

      {/* NDA Agreement Window */}
      {showWindow && (
        <NdaAgreementWindow onClose={() => setShowWindow(false)} />
      )}
    </div>
  );
}
